module.exports = __webpack_public_path__ + "static/media/201CS160.a16718cc.jpg";